<template>
  <div class="login content">
    <div class="login-image">
      <img src="../assets/peoplelink.png" alt="People networking" />
    </div>
    <div class="login-form">
      <router-link to="/" class="site-logo d-none d-md-block"
        ><img src="../assets/logo.png" alt="Logo"
      /></router-link>
      <p>{{ $t("login.welcome") }}</p>
      <div class="form">
        <div class="enter-phone" v-if="!codeSent">
          <vue-tel-input v-model="phone" v-bind="telInputProps" ref="telInput"></vue-tel-input>
          <div class="btn btn-gold w-100 text-white" @click="sendCode">
            {{ $t("login.login") }}
          </div>
          <span>{{ $t("login.forgot") }}</span>
        </div>
        <div v-else class="enter-code">
          <input type="password" maxlength="6" v-model="validationCode" />
          <div class="w-100 d-inline-flex justify-content-between">
            <span v-if="countdown > 0">{{
              $t("login.countdown", { countdown: countdown })
            }}</span>
            <span class="color-gold" @click="resendCode">{{
              $t("login.resend")
            }}</span>
          </div>
          <div class="btn btn-gold w-100 text-white" @click="login">
            {{ $t("login.login") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import {postCodeforLogin, postSMSforLogin} from "@/network/api";

export default {
  components: {
    VueTelInput,
  },
  data() {
    return {
      phone: "",
      telInputProps: {
        defaultCountry: "US",
        inputOptions: {
          placeholder: "(555) 555-5254",
          showDialCode: true,
          styleClasses: "dj-vue-tel-input",
        },
      },
      validationCode: "123456",
      codeSent: false,
      countdown: 0,
      timer: null,

      /****/
      phoneObject:{
        countryCode:"",
        phone:""
      }
    };
  },
  methods: {
    async sendCode() {
      this.phoneObject = this.$refs.telInput.phoneObject;
      // 判断手机位数
      if (this.phoneObject.nationalNumber.length > 5) {
        let res = await postSMSforLogin({"countryCode": this.phoneObject.countryCallingCode, "phone": this.phoneObject.nationalNumber});
        this.codeSent = true;
        this.countdown = 60;
        this.counDownTimer();
      }
    },
    counDownTimer() {
      if (this.countdown > 0) {
        this.timer = setTimeout(() => {
          this.countdown -= 1;
          this.counDownTimer();
        }, 1000);
      }
    },
    resendCode() {
      this.codeSent = true;
      this.countdown = 60;
      this.validationCode = "123456";
      clearTimeout(this.timer);
      this.counDownTimer();
    },
    async login() {
      //this.phoneObject = this.$refs.telInput.phoneObject;
      let data = {"countryCode": this.phoneObject.countryCallingCode, "phone": this.phoneObject.nationalNumber,code: this.validationCode};
      // var send_data = {
      //   phone: this.$store.state.loginInfo.phone,
      //   countryCode: this.$store.state.loginInfo.countryCode,
      //   code: this.code
      // }
      console.log(data);
      //await postCodeforLogin(data);
      //----------------
      // 这里将来应该调用API接口获取用户信息
      // localStorage.removeItem("user");
      // localStorage.removeItem("token");
      // const userObj = {
      //   id: 1,
      //   name: "Ana",
      //   phone: this.phone,
      //   avatar: "/images/users/default-avatar.png",
      // };
      // const token =
      //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoiQW5hIiwicGhvbmUiOiIxMjM0NTY3ODkwMSJ9.2S4s6acNhiAamSpR2UABs5JE2J8f7zCnDlD3jaqMIMI";
      // localStorage.setItem("user", JSON.stringify(userObj));
      // localStorage.setItem("token", token);
      // const store = localStorage.getItem("token");
      // console.log('store:', store);
      // if (store) this.$router.push("/dashboard");
    },
  },
};
</script>

<style>
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin: 5rem auto;
  .login-image {
    width: 100%;
    text-align: center;
    img {
      width: 60%;
    }
  }
  .login-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    p {
      font-size: 1.9rem;
      text-align: center;
      width: 23rem;
    }
    .form {
      background-color: white;
      padding: 2rem 1.5rem;
      border-radius: 1rem;
      .enter-phone,
      .enter-code {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1.5rem;
        width: 20rem;
        .vue-tel-input {
          border-radius: 0.5rem;
          width: 100%;
          height: 50px;
          input {
            border-radius: 0.5rem;
            height: auto;
          }
        }
        input {
          width: 100%;
          height: 50px;
          border: 1px solid #f2f3f4;
          border-radius: 0.5rem;
        }
        input[type="password"] {
          position: relative;
          text-align: center;
          letter-spacing: 2rem;
          font-family: Verdana;
        }
        .btn {
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: 700;
          border-radius: 1rem;
        }
        span {
          color: #848a9c;
        }
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .login {
    flex-direction: row;
    justify-content: space-around;
    .login-image {
      width: 50%;
    }
    .login-form {
      width: 50%;
      align-items: flex-start;
      p {
        text-align: left;
      }
    }
  }
}
</style>
